import CloseIcon from '@/components/Icon/CloseIcon';
import IconButton from '@/components/IconButton/IconButton';
import SeasonIllustrationBackground from '@/components/SeasonIllustrationBackground/SeasonIllustrationBackground';
import useSeason from '@/hooks/useSeason';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { motion, useReducedMotion } from 'framer-motion';
import AchievementsOverview, {
	AchievementsOverviewProps,
} from './AchievementsOverview';

export type AchievementsOverviewDialogProps = Omit<
	AchievementsOverviewProps,
	'isInsideDialog'
> & {
	onClose: () => void;
};

const AchievementsOverviewDialog = ({
	onClose,
	...overviewProps
}: AchievementsOverviewDialogProps) => {
	const reduceMotion = useReducedMotion();
	const season = useSeason();

	return (
		<Dialog
			static
			open
			onClose={onClose}
			className="relative z-50 overflow-hidden">
			<SeasonIllustrationBackground>
				<div className="absolute inset-0 size-full bg-accent opacity-40" />
				<motion.img
					alt=""
					src={`/assets/illustrations/top_start_${season}.svg`}
					className="absolute me-auto max-w-xs"
					initial={{ opacity: 0, y: reduceMotion ? '-10%' : '-40%' }}
					animate={{ opacity: 1, y: '-10%' }}
					exit={{ opacity: 0, y: reduceMotion ? '-10%' : '-40%' }}
				/>
				<div className="fixed inset-0 grid h-screen w-screen overflow-y-auto overflow-x-clip text-accentCompat">
					<DialogPanel
						as={motion.div}
						initial={{ opacity: 0, y: reduceMotion ? 0 : '-50%' }}
						animate={{
							opacity: 1,
							y: 0,
							transition: { ease: 'easeOut' },
						}}
						exit={{
							opacity: 0,
							y: reduceMotion ? 0 : '-10%',
							transition: { ease: 'easeIn', duration: 0.2 },
						}}>
						<div className="fixed start-1/2 top-4 z-50 -translate-x-1/2">
							<IconButton
								onClick={onClose}
								aria-label="Terug"
								title="Terug"
								animationDelay={0.5}
								icon={<CloseIcon />}
							/>
						</div>

						<AchievementsOverview
							{...overviewProps}
							headingElement={DialogTitle}
							isInsideDialog
						/>

						<img
							alt=""
							src={`/assets/illustrations/bottom_start_${season}.svg`}
							className="me-auto max-w-xs"
						/>
					</DialogPanel>
				</div>
			</SeasonIllustrationBackground>
		</Dialog>
	);
};

export default AchievementsOverviewDialog;
